import * as axios from "axios";
import StyleTransform from "@/utils/styleTransform";

const USER_CENTER_BASE_URL = "https://www.xkool.ai/api/user_center";

const getUrl = (path) => `${USER_CENTER_BASE_URL}${path}`;

export default class UserApi {
  /**
   * 获取验证码
   * @param {Object} data {手机号或邮箱, 验证码类型, token}
   */
  static fetchDynamicCode(data) {
    return axios.get(getUrl("/v1/dynamic_code"), {
      params: StyleTransform.convertKeysToSnakeCase(data),
    });
  }

  /**
   * 密码登录
   * @param {Object} data {手机号或邮箱, 密码}
   */
  static login(data) {
    let params = {
      ...StyleTransform.convertKeysToSnakeCase(data),
      login_terminal: 1,
    };
    return axios.post(getUrl("/v2/password_login"), params);
  }

  /**
   * 验证码登录
   * @param {Object} data {手机号或邮箱, 验证码}
   */
  static dynamicCodeLogin(data) {
    let params = {
      ...StyleTransform.convertKeysToSnakeCase(data),
      login_terminal: 1,
    };
    return axios.post(getUrl("/v2/dynamic_login"), params);
  }

  /**
   * 注册
   * @param {Object} data {手机号或邮箱, 验证码, 密码}
   */
  static register(data) {
    return axios.post(
      getUrl("/v2/register"),
      StyleTransform.convertKeysToSnakeCase(data)
    );
  }

  /**
   * 获取微信登录二维码配置
   */
  static fetchWeixinConfig() {
    return axios.get(getUrl("/v1/wx_open_platform/configuration"));
  }

  /** 获取微信登录唯一标识码 */
  static fetchWeixinUnionId(code) {
    return axios.post(getUrl("/v1/wx_open_platform/unionid"), { code });
  }

  /** 微信登录 */
  static weixinLogin(unionId) {
    return axios.post(getUrl("/v1/wx_open_platform/login"), {
      union_id: unionId,
    });
  }

  /**
   * 绑定用户微信
   * @param {Object} data {手机号或邮箱, 动态验证码, unionId}
   */
  static bindWeixin(data) {
    return axios.patch(
      getUrl("'/v1/wx_open_platform/binding"),
      StyleTransform.convertKeysToSnakeCase(data)
    );
  }
}
